import SortingListView from "../view/sorting-list.js";
import SortingButtonView from "../view/sorting-button.js";

import SortingModel from "../model/sorting.js";

import {
  defaultSortingModelData,
  ActionType,
  SortDir
} from "../const.js";

import {
  ActionType as FavoriteDataActionType
} from "../../favorite-data/const.js";

export default class Sorting {
  constructor(listElement) {
    this._listElement = listElement;

    this._listView = null;
    this._buttonsViews = [];

    this._model = null;

    this._handleSortingButtonClick = this._handleSortingButtonClick.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
  }

  init() {
    this._listView = new SortingListView(this._listElement);

    Array.from(this._listView.getButtons())
      .forEach((button, index) => {
        const view = new SortingButtonView(button, index);
        view.setClickHandler(this._handleSortingButtonClick);
        this._buttonsViews.push(view);
      });

    const activeSortingView = this._buttonsViews
      .slice()
      .filter((view) => view.isActive())[0];

    this._model = new SortingModel(Object.assign(
        {},
        defaultSortingModelData,
        {
          sortName: activeSortingView.getSortName(),
          sortDir: activeSortingView.getSortDir()
        }
    ));
    this._model.addObserver(this._handleChangeData);
  }

  getActiveSorting() {
    const modelData = this._model.getData();

    return (modelData.sortName && modelData.sortDir) ?
      `${modelData.sortName}-${modelData.sortDir}` :
      null;
  }

  _activateSortingButton(currentIndex) {
    this._buttonsViews.forEach((view, index) => {
      if (currentIndex === index) {
        view.activate();
      } else {
        view.deactivate();
      }
    });

    this._sortFavoriteProducts();
  }

  _changeSortingDirection(currentIndex, newSortDir, oldSortDir) {
    this._buttonsViews[currentIndex].setSortDir(newSortDir, oldSortDir);
    this._sortFavoriteProducts();
  }

  _sortFavoriteProducts() {
    if (window.FavoriteData) {
      window.FavoriteData.changeData(Object.assign(
          {},
          window.FavoriteData.getData()
      ), FavoriteDataActionType.SORT);
    }
  }

  _handleSortingButtonClick({
    sortName,
    sortDir,
    index
  }) {
    const modelData = this._model.getData();

    if (modelData.isLoading) {
      return;
    }

    if (sortName !== modelData.sortName) {
      this._model.changeData(Object.assign(
          {},
          modelData,
          {
            sortName,
            sortDir
          }
      ), ActionType.ACTIVATE_SORTING_BUTTON, {
        index
      });

      return;
    }

    let newSortDir;

    if (!sortDir || sortDir === SortDir.NONE) {
      newSortDir = SortDir.NONE;
    } else {
      newSortDir = (sortDir === SortDir.DESC) ? SortDir.ASC : SortDir.DESC;
    }

    if (newSortDir === SortDir.NONE) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        modelData,
        {
          sortDir: newSortDir
        }
    ), ActionType.CHANGE_SORTING_DIRECTION, {
      index,
      newSortDir,
      oldSortDir: modelData.sortDir
    });
  }

  _handleChangeData(action, payload) {
    switch (action) {
      case ActionType.CHANGE_SORTING_DIRECTION:
        this._changeSortingDirection(payload.index, payload.newSortDir, payload.oldSortDir);
        break;
      case ActionType.ACTIVATE_SORTING_BUTTON:
        this._activateSortingButton(payload.index);
        break;
    }
  }
}
